import React  from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Typography } from '@mui/material'
import { KeyboardReturn } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import navigation from '../../config/navigation'
import UserService from '../../store/services/UserService'

const NotFoundView = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  let redirect = navigation.login
  if (UserService.isLoggedIn()) redirect = navigation.loading

  return (
    <Box
      sx={{
        bgcolor: 'background.main',
        color: 'text.base',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h3" color={'text.highEmphasis'}>
        {t('page.notFound.title')}
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        {t('page.notFound.message')}
      </Typography>
      <Button variant="contained" startIcon={<KeyboardReturn />} sx={{ mt: 6 }} onClick={() => navigate(redirect)}>
        {t('page.notFound.return')}
      </Button>
    </Box>
  )
}

export default NotFoundView
